import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
var Arrow = function(props) {
    return /*#__PURE__*/ _jsx("svg", {
        width: "9",
        height: "16",
        viewBox: "0 0 9 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M1 1.0354L7.54545 7.58086L1 14.1263",
            stroke: props.stroke || "#333",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
export default /*#__PURE__*/ memo(Arrow);
